import { delay } from 'redux-saga'
import normalize from 'jsonapi-normalizer'
import T from 'i18n-react'
import {
  takeLatest,
  take,
  fork,
  all,
  call,
  select,
  put,
} from 'redux-saga/effects'

import {
  buildUrl,
} from 'helpers/actionHelper'

import {
  getRequest,
  patch,
} from 'helpers/RequestUtil'

import {
  success,
  error,
} from 'containers/App/Notification/actions'

import {
  countSelector,
  pageSizeSelector,
  currentPageSelector,
  searchValueSelector,
  editSelector,
} from './selectors'

import {
  CHANGE_EDIT,
  CHANGE_CURRENT_PAGE,
  CHANGE_PAGE_SIZE,
  CHANGE_SEARCH_VALUE,
  CHANGE_SELECT_SITE,
  FETCH_NVBUGS,
  PATCH_NVBUGS
} from './constants'

import {
  updateEdit,
  updatePageSize,
  updateCountSize,
  updateCurrentPage,
  updateSearchValue,
  updateSelectSite,
  clearNvbugsList,
  updateNvbugsList,
  fetchNvbugsStart,
  fetchNvbugsSuccess,
  fetchNvbugsError,
  startFetchNvbugsAsync,
} from './actions'

import {
  updateTablesAction
} from 'containers/Entity/actions'
import { updateNvbugsId } from '../NvbugsDialog/actions'
import { removeTables } from '../../../Entity/actions'

function* fetchNvbugs(url) {
  try {
    yield put(startFetchNvbugsAsync())
    yield put(fetchNvbugsStart())
    const data = yield call(
      getRequest,
      url
    )
    const normalized = normalize(data)
    yield put(updateTablesAction(normalized))
    yield put(fetchNvbugsSuccess())
    return data
  } catch(error) {
    yield put(fetchNvbugsError(error))
  }
}

function* handleFetchNvbugs() {
  let params = []
  yield call(delay, 500)
  const page = yield select(currentPageSelector)
  const size = yield select(pageSizeSelector)
  const search = yield select(searchValueSelector)

  if (search)
    params = [...params, { type: 'search', value: search }]

  const url = buildUrl('/api/fulcrum/manage/nvbugs/nvbug_unassociated_views', ...params)
    .concat(`&page[number]=${page}&page[size]=${size}`)

  const data = yield call(fetchNvbugs, url)
  const normalized = normalize(data)
  const { result: { nvbug_unassociated_views : list } } = normalized
  yield put(updateCountSize(data.meta.totalCount))
  yield put(updateNvbugsList(list ? list : []))
}

function* handleChangePageSize(action) {
  const { size } = action
  const page = yield select(currentPageSelector)
  const prevSize = yield select(pageSizeSelector)
  let newPage = Math.floor((page - 1) * prevSize / size)
  newPage = (newPage > 0)
    ? newPage
    : newPage + 1

  yield put(updatePageSize(size))
  yield put(updateCurrentPage(newPage))
  yield fork(handleFetchNvbugs)
}

function* handleChangeCurrentPage(action) {
  const { value } = action
  const page = yield select(currentPageSelector)
  yield put(updateCurrentPage(page + value))
  yield fork(handleFetchNvbugs)
}

function* handleSearchChange(action) {
  const { value } = action
  yield put(updateCurrentPage(1))
  yield put(clearNvbugsList())
  yield put(updateSearchValue(value))
  yield fork(handleFetchNvbugs)
}

function* handleChangeSelectSite(action) {
  const { id, synopsis } = action
  yield put(updateSelectSite(id))
  yield put(updateNvbugsId(id, synopsis))
}

function* handleChangeEdit(action) {
  const { enable } = action
  yield put(updateCurrentPage(1))
  yield put(updateEdit(enable))
  yield put(clearNvbugsList())
  yield fork(handleFetchNvbugs)
}

function* watchChangeSelectSite() {
  yield takeLatest(CHANGE_SELECT_SITE, handleChangeSelectSite)
}

function* watchFetchNvbugs() {
  yield takeLatest(FETCH_NVBUGS, handleFetchNvbugs)
}

function* watchChangePageSize() {
  yield takeLatest(CHANGE_PAGE_SIZE, handleChangePageSize)
}

function* watchChangeCurrentPage() {
  yield takeLatest(CHANGE_CURRENT_PAGE, handleChangeCurrentPage)
}

function* watchSearchChange() {
  yield takeLatest(CHANGE_SEARCH_VALUE, handleSearchChange)
}

function* watchChangeEdit() {
  yield takeLatest(CHANGE_EDIT, handleChangeEdit)
}

function* loadSagas() {
  yield all([
    fork(watchFetchNvbugs),
    fork(watchChangePageSize),
    fork(watchChangeCurrentPage),
    fork(watchSearchChange),
    fork(watchChangeSelectSite),
    fork(watchChangeEdit)
  ])
}

export default loadSagas
